export const SET_AUTH = 'setAuth';
export const SET_USER = 'setUser';
export const SET_POSTS = 'setPosts';
export const CLEAR_POSTS = 'clearPosts';
export const SET_POST = 'setPost';
export const SET_TARGET_ROUTE = 'setTargetRoute';
export const CLEAR_TARGET_ROUTE = 'clearTargetRoute';
export const SET_GLOBAL_NOTIFICATION = 'setGlobalNotification';
export const SET_UNREAD_NOTIFICATIONS_LIST = 'setUnreadNotificationsList';



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js